<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{boardNm}} 고정글 템플릿 편집</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body">

        <vue-editor class="" v-model="template" ></vue-editor>
      </div>
      <div class="modal-footer">
            <el-button type="primary" @click="submitForm()">저 장</el-button>
            <el-button @click="$emit('dismiss')">닫 기</el-button>

<!-- 
        <button type="button" class="btn btn-secondary" @click="hideAll" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click="other">Save changes</button> -->


      </div>
    </div>

</template>

<script>
import { mapState } from 'vuex'
import {VueEditor} from "vue2-editor";
import BoardProxy from '@/proxies/BoardProxy';

export default {
    components: {
      VueEditor
    },
    mounted() {
      new BoardProxy()
      .getBoardMstInfo(this.boardNo)
      .then(res => {
        this.template = res.item.template
      });     
    },
    props: {
      boardNo: {
          type: String
      },
      boardNm: String
    },
    data() {
      return {
        template: '',
      };
    },    
    methods: {
        submitForm() {
            new BoardProxy()
            .updateTemplate(this.boardNo, this.template)
            .then(res=> {
              this.$emit('close');
              alert('저장 되었습니다.')
            });
        },
    },

}
</script>